import { emailArray } from "../components/services";
import { Link } from "gatsby";
import MailIcon from "../svgs/MailIcon";
import React from "react";
import routes from "../routes";
import * as styles from "../styles/footerStyles";
import TelIcon from "../svgs/TelIcon";
import Logo1 from "../svgs/Logo1";

const Footer = () => {
  const ui = styles.uiFooter;
  return (
    <ui.Footer>
      <ui.ContactContainer>
        <div>
          <ui.LogoContainer>
            <Logo1 />
            <ui.Name>
              名古屋市立大学大学院医学研究科
              <br />
              心臓血管外科学教室
            </ui.Name>
          </ui.LogoContainer>
          <ui.Address>〒467-0001 名古屋市瑞穂区瑞穂町川澄1</ui.Address>
        </div>
        <div>
          <ui.TelContainer>
            <TelIcon />
            <ui.TelInnerContainer>
              <ui.Tel>
                <ui.TelLink href="tel:052-853-8077">052-853-8077</ui.TelLink>
                <ui.TelAnnotation>(名古屋市立大学大学院医学研究科：代表)</ui.TelAnnotation>
              </ui.Tel>
              <ui.Tel>
                <ui.TelLink href="tel:052-851-5511">052-851-5511</ui.TelLink>
                <ui.TelAnnotation>(名古屋市立大学病院：代表)</ui.TelAnnotation>
              </ui.Tel>
            </ui.TelInnerContainer>
          </ui.TelContainer>
          <ui.MailIconContainer>
            <MailIcon />
            <a href={`mailto:${emailArray.join("")}`}>{emailArray.join("")}</a>
          </ui.MailIconContainer>
        </div>
      </ui.ContactContainer>
      <ui.LinkContainer>
        <ui.LinkList>
          <ui.LinkGroup1>
            <Link key="footer-link0" to={routes.rootPath()}>
              トップ
            </Link>
            <Link key="footer-link1" to={routes.patientsPath()}>
              患者様へご案内
            </Link>
            <Link key="footer-link2" to={routes.professionalsPath()}>
              医療関係者の方へ
            </Link>
          </ui.LinkGroup1>
          <ui.LinkGroup2>
            <Link key="footer-link3" to={routes.aboutPath()}>
              当科の紹介
            </Link>
            <Link key="footer-link4" to={routes.networkPath()}>
              NCU HEART PROJECT
            </Link>
          </ui.LinkGroup2>
        </ui.LinkList>
        <ui.Copyright>Copyright (C) NCU herz 2021</ui.Copyright>
      </ui.LinkContainer>
    </ui.Footer>
  );
};
export default Footer;
